import React from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';

import BgImg from './images/bg.png';

const ContactBlock = () => {
    const navigate = useNavigate();

    return (
        <Container
            component="section"
            sx={{
                backgroundColor: '#563BD4',
                backgroundImage: `url(${BgImg})`,
                backgroundSize: 'cover',
            }}
        >
            <Box
                sx={{
                    maxWidth: (theme) => theme.breakpoints.values.desktop,
                    width: '100%',
                    margin: '0 auto',
                    pb: { tablet: 20, mobile: 10 },
                }}
            >
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        pt: { tablet: 14, mobile: 5 },
                    }}
                >
                    <Grid
                        item
                        mobile={12}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <span style={{ textAlign: 'center' }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    pb: 3,
                                    fontSize: 40,
                                    color: 'white',
                                }}
                            >
                                Try Virtual Law Clinic for 14 days, for free!
                            </Typography>
                            <Typography
                                variant="body1"
                                style={{
                                    color: 'white',
                                }}
                            >
                                Reach out to get a private trial account for your organization.
                            </Typography>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => navigate('/demo')}
                                style={{
                                    marginTop: 30,
                                }}
                            >
                                Contact Us
                            </Button>
                        </span>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default ContactBlock;
